module.exports = __webpack_public_path__ + "img/illustration-categories-1-mobile.ff9a4d98.gif";